<template>
    <div v-if="isLoading" class="tw:fixed tw:inset-0 tw:z-2000 tw:bg-brand-primary/10">
        <span
            class="tw:absolute tw:top-1/2 tw:left-1/2 tw:size-12.5 tw:animate-loader tw:before:block tw:before:size-5 tw:before:rounded-full tw:before:bg-white tw:before:mb-2.5 tw:before:animate-loader-ball-1 tw:after:block tw:after:size-5 tw:after:rounded-full tw:after:bg-brand-primary tw:after:animate-loader-ball-2"></span>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "LoadingPage",
    computed: {
        ...mapState(['isLoading'])
    },
}
</script>
